import { createContext, useCallback, useEffect, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
// utils
// import axios from '../utils/axios';
import axios from 'axios';
// Camalize and decamelize json 
import humps from 'humps';
import useLocalStorageState from 'use-local-storage-state'
import Cookies from "js-cookie";
import { isValidToken, setSession, setUserData, setCompanyData } from '../utils/jwt';
// API
// import { URL } from "../backend";

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user
    };
  },
  LOGIN: (state, action) => {
    // console.log(action.payload);
    const { data } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      data
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user
    };
  },
  GET_CITY_NAME: (state, action) => {
    const cityDetails = action.payload;
    console.log(action.payload)
    console.log(cityDetails)

    return {
      ...state,
      isAuthenticated: true,
      cityDetails
    };
  }
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve()
});

AuthProvider.propTypes = {
  children: PropTypes.node
};

function AuthProvider({ children }) {
  const [companyLSData, setCompanyLSData] = useLocalStorageState('companyData');
  const [state, dispatch] = useReducer(reducer, initialState);
  const [headerLogo, setHeaderLogo] = useState();
  const [favIconLogo, setFavIconLogo] = useState();
  const [loginLogo, setLoginLogo] = useState();
  const [profilePicture, setProfilePicture] = useState();
  const [enableTwoStep, setEnableTwoStep] = useState(false);
  const [mfaRequired, setMfaRequired] = useState(false);
  const [isExtId, setIsExtId] = useState();
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const accessToken = window.localStorage.getItem('accessToken');

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');

        if (accessToken) {
          setSession(accessToken);
          // const response = await axios.get('/api/account/my-account');
          // const { user } = response.data;

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user: null
            }
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null
            }
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
      }
    };

    initialize();
  }, []);
  const login = async (email, password, dId, enableTwoStep, otp, deviceChecked) => {

    const completeLogin = (token, data) => {
      setEnableTwoStep(false);
      setSession(token);
      setUserData(data);
      if (typeof getProfilePicture === 'function') getProfilePicture();
      dispatch({
        type: 'LOGIN',
        payload: { isAuthenticated: true, data }
      });
    };

    // --- CASE 1: VERIFYING OTP (Step 2) ---
    if (enableTwoStep) {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/verify_otp`, {
          email,
          otp,
          device_id: dId
        });

        const { token, data } = humps.camelizeKeys(response.data);
        completeLogin(token, data);
        return response.data;
      } catch (error) {
        console.error('Verify otp error', error);
        throw error;
      }
    }

    // --- CASE 2: INITIAL LOGIN (Step 1) ---
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/login`, {
        email,
        password,
        device_id: dId
      });

      const camelized = humps.camelizeKeys(response.data);
      const { token, data, deviceId, isOtpSent, mfaRequired } = camelized;

      // Check for MFA (Authenticator App)
      if (mfaRequired) {
        setEnableTwoStep(true);
        setMfaRequired(true);
        return response.data;
      }

      // Handle Device/OTP Logic
      const cookieKey = `device_ids_${window?.location?.hostname}`;
      const devices = Cookies.get(cookieKey) ? JSON.parse(Cookies.get(cookieKey)) : {};
      const encodedEmail = btoa(email);
      const storedDeviceId = devices[encodedEmail] || '';

      /**
       * Checking isOtpSent FIRST. 
       * Even if device IDs match, if the api response indicates an OTP was sent, 
       * we MUST show the OTP screen and NOT call completeLogin.
       */
      if (isOtpSent) {
        setEnableTwoStep(true);
        // We return here so the user stays on the OTP input screen
        return response.data;
      }

      // If No OTP sent, check if device is recognized to auto-login
      // (Or if user recognized devices then we skip OTP entirely)
      if (!isOtpSent) {
        setIsExtId(true);
        completeLogin(token, data);
      }

      return response.data;

    } catch (error) {
      console.error('Login error', error);
      throw error;
    }
  };
  const verifyMfaOtp = async (email, mfaOtp) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/mfa/verify_mfa_otp`,
        humps.decamelizeKeys({ mfa_otp: mfaOtp, email }),
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      const responseData = response?.data?.data || response?.data;
      const camelized = humps.camelizeKeys(responseData);
      const token = camelized.token || response?.data?.token;
      // API returns { token, user_data, mfa_verified, message } – user_data is the user object with id, email, etc.
      const userData = camelized.userData || camelized.data || response?.data?.user_data || camelized;
      if (!token) throw new Error('Invalid response from MFA verification');
      setEnableTwoStep(false);
      setMfaRequired(false);
      setSession(token);
      setUserData(userData);
      getProfilePicture();
      dispatch({
        type: 'LOGIN',
        payload: {
          isAuthenticated: true,
          data: userData
        }
      });
      return response?.data;
    } catch (error) {
      console.error('Verify MFA OTP error', error);
      throw error;
    }
  };

  const verifyMfaBackupCode = async (email, backupCode) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/mfa/verify_backup_code`,
        humps.decamelizeKeys({ email, backup_code: backupCode }),
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      const responseData = response?.data?.data || response?.data;
      const camelized = humps.camelizeKeys(responseData);
      const token = camelized.token || response?.data?.token;
      const userData = camelized.userData || camelized.data || response?.data?.user_data || camelized;
      if (!token) throw new Error('Invalid response from MFA backup code verification');
      setEnableTwoStep(false);
      setMfaRequired(false);
      setSession(token);
      setUserData(userData);
      getProfilePicture();
      dispatch({
        type: 'LOGIN',
        payload: {
          isAuthenticated: true,
          data: userData
        }
      });
      return response?.data;
    } catch (error) {
      console.error('Verify MFA backup code error', error);
      throw error;
    }
  };

  const twoStepResendOtp = async (email) => {

    const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/resend_otp`, JSON.stringify({
      'email': email,
    }), {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  // const verifyOtp = async (email, otp, deviceId) => {

  //   // Calling Sign-in API
  //   // try {
  //   const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/verify_otp`, JSON.stringify({
  //     email,
  //     otp,
  //     device_id: deviceId
  //   }), {
  //     headers: {
  //       'Content-Type': 'application/json'
  //     }
  //   });

  //   const { token, data } = humps.camelizeKeys(response.data);

  //   setSession(token);
  //   setUserData(data);
  //   getProfilePicture();
  //   dispatch({
  //     type: 'LOGIN',
  //     payload: {
  //       isAuthenticated: true,
  //       data
  //     }
  //   });


  // };

  const changePassword = async (password) => {

    const accessToken = window.localStorage.getItem('accessToken');

    // Calling reset password API
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/set_password`, JSON.stringify({
      password,
      token: accessToken
    }), {
      headers: {
        'Content-Type': 'application/json'
      }
    });


    // console.log("response", response.data);
    const { token, data } = humps.camelizeKeys(response.data);

    setSession(token);
    setUserData(data);
    dispatch({
      type: 'LOGIN',
      payload: {
        isAuthenticated: true,
        data
      }
    });
  };

  const changeUserPassword = async (currentPassword, password) => {

    const accessToken = window.localStorage.getItem('accessToken');

    try {
      // Calling reset password API
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/staff/reset_password`, JSON.stringify(humps.decamelizeKeys({
        password,
        currentPassword
      })), {
        headers: {
          'Authorization': `Token ${accessToken}`,
          'Content-Type': 'application/json'
        }
      });

      return response;

    } catch (err) {
      // Handle Error Here
      console.error(err);
      const { data } = humps.camelizeKeys(err.response);
      return data;
    }

  };

  const userslocalisation = async (localisation) => {
    const userData = JSON.parse(window.localStorage.getItem('userData'));
    const userId = userData.id;
    // console.log(userId)
    const accessToken = window.localStorage.getItem('accessToken');

    const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/localisation`, JSON.stringify(humps.decamelizeKeys({
      localisation
    })), {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'application/json'
      }
    });
  };

  const updateProfilePicture = async (file) => {
    // console.log("file.............", file);

    const accessToken = window.localStorage.getItem('accessToken');

    // Calling reset password API
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/profile_pic_update`, {
      file
    }, {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    // console.log("response", response);

    // const res = await getProfilePicture();
    return response;
  }


  const getProfilePicture = async (scoreCardId) => {
    const accessToken = window.localStorage.getItem('accessToken');

    const data = await axios.get(`${process.env.REACT_APP_API_URL}/users/profile_pic`, {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {

        // console.log(res);
        const loggedUserData = JSON.parse(window.localStorage.getItem('userData'))

        const results = res.data.data;
        // console.log("picture", results)
        if (!results || results !== null) {
          setProfilePicture(res.data.data);
          setUserData({ ...loggedUserData, profilePicture: results });
        }
        return results;
        // dispatch({
        //     type: 'GET_SINGLE_SCORECARD',
        //     payload: results,
        // })
      })
      .catch((error) => {
        console.error(error)
      })

    return data;
  }

  const deleteProfilePicture = async () => {
    const accessToken = window.localStorage.getItem('accessToken');

    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/users/profile_pic_delete`, {
      headers: {
        'Authorization': `Token ${accessToken}`
      }
    });
    setProfilePicture(undefined);
    const loggedUserData = JSON.parse(window.localStorage.getItem('userData'))
    delete loggedUserData?.profilePicture;
    setUserData({ ...loggedUserData });
    return response;
  }

  // MFA: setup (returns QR data), verify (enable with code), status
  const setupMfa = async () => {
    const accessToken = window.localStorage.getItem('accessToken');
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/user/mfa/create_mfa`,
      {},
      {
        headers: {
          Authorization: `Token ${accessToken}`,
          'Content-Type': 'application/json'
        }
      }
    );
    const data = humps.camelizeKeys(response?.qr_code || response?.data);
    return data;
  };

  const verifyMfa = async (code) => {
    const accessToken = window.localStorage.getItem('accessToken');
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/user/mfa/verify_mfa_setup`,
      humps.decamelizeKeys({ mfa_otp: code }),
      {
        headers: {
          Authorization: `Token ${accessToken}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return humps.camelizeKeys(response?.data?.data || response?.data);
  };

  const getMfaStatus = useCallback(async () => {
    const accessToken = window.localStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/mfa/get_status_of_mfa`, {
      headers: {
        Authorization: `Token ${accessToken}`,
        'Content-Type': 'application/json'
      }
    });
    return humps.camelizeKeys(response?.data?.data || response?.data);
  }, []);

  const forgotPassword = async (email) => {

    const accessToken = window.localStorage.getItem('accessToken');

    // Calling forgot password API
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/forgot_password`, JSON.stringify({
      email
    }), {
      headers: {
        'Content-Type': 'application/json'
      }
    });


    // console.log("response", response.data);
    // const { token, data } = humps.camelizeKeys(response.data);

    // setSession(token);
    // dispatch({
    //   type: 'LOGIN',
    //   payload: {
    //     isAuthenticated: true,
    //     data
    //   }
    // });
  };


  // Get company settings
  const getCompanySettings = async () => {
    const accessToken = window.localStorage.getItem('accessToken');

    const data = await axios.get(`${process.env.REACT_APP_API_URL}/company_settings/1`, {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {

        // console.log(res);

        const results = humps.camelizeKeys(res.data);
        // setCompanyData(results);
        setCompanyLSData(results);
        return results;
        // dispatch({
        //     type: 'GET_SINGLE_SCORECARD',
        //     payload: results,
        // })
      })
      .catch((error) => {
        console.error(error)
      })

    return data;
  }

  const updateSideBar = async (obj) => {
    const data = axios.post(`${process.env.REACT_APP_API_URL}/users/show_sidebar`, JSON.stringify(humps.decamelizeKeys(obj)),
      {
        headers: {
          'Authorization': `Token ${accessToken}`,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        console.log('res of sidebar ', res)
        return res
      }).catch((err) => {
        console.error('error while update', err)
        throw err
      })
    return data
  }
  const getSideBar = async (userId) => {
    const data = axios.get(`${process.env.REACT_APP_API_URL}/users/show_sidebar?user_id=${userId}`,
      {
        headers: {
          'Authorization': `Token ${accessToken}`,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        const results = humps.camelizeKeys(res.data);
        return results
      }).catch((err) => console.error(err))
    return data
  }
  // Update company settings
  // const updateCompanySettings = async (fileAttachments, inbox, supportAccess, autoScore, activityLog, timezone, dateFormat, requestFlow) => {
  //   // console.log(scoreCardId, fieldsName, fieldValue);
  //   const accessToken = window.localStorage.getItem('accessToken');

  //   const response = await axios.patch(`${process.env.REACT_APP_API_URL}/company_settings/1`, JSON.stringify(humps.decamelizeKeys({
  //     fileAttachments,
  //     inbox,
  //     supportAccess,
  //     autoScore,
  //     activityLog,
  //     timezone,
  //     dateFormat,
  //     requestFlow
  //   })), {
  //     headers: {
  //       'Authorization': `Token ${accessToken}`,
  //       'Content-Type': 'application/json'
  //     }
  //   });
  // };

  // Update company settings
  const updateCompanySettings = async (obj) => {
    // console.log(scoreCardId, fieldsName, fieldValue);
    const accessToken = window.localStorage.getItem('accessToken');

    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/company_settings/1`, JSON.stringify(humps.decamelizeKeys(obj)), {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'application/json'
      }
    });
    const companyData = humps.camelizeKeys(response?.data);
    // console.log(companyData);
    setCompanyLSData(companyData);
  };

  const logout = async () => {
    setSession(null);
    setEnableTwoStep(false);
    setMfaRequired(false);
    dispatch({ type: 'LOGOUT' });
  };

  const updateLogo = async (file) => {
    console.log("file.............", file);

    const accessToken = window.localStorage.getItem('accessToken');

    // Calling reset password API
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/company_settings/logo_update`, {
      file
    }, {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  const deleteHeaderLogo = async () => {
    const accessToken = window.localStorage.getItem('accessToken');

    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/company_settings/logo_delete`, {
      headers: {
        'Authorization': `Token ${accessToken}`
      }
    });

  }

  const updateFavIcoLogo = async (file) => {
    // console.log("file.............", file);

    const accessToken = window.localStorage.getItem('accessToken');

    // Calling reset password API
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/company_settings/logo_update`, {
      file,
      type: "favicon"
    }, {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  const deleteFavIcoLogo = async () => {
    const accessToken = window.localStorage.getItem('accessToken');

    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/company_settings/logo_delete?type="favicon"`, {
      headers: {
        'Authorization': `Token ${accessToken}`
      }
    });

  }

  const getLoginLogo = async () => {

    const data = await axios.get(`${process.env.REACT_APP_API_URL}/users/get_logo`, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        const results = res.data;
        // console.log("logo1", res.data.data)
        return results;
      })
      .catch((error) => {
        console.error(error)
      })

    return data;
  }

  // Fetch Superset credentials (username, password) from BeyondQA AI API
  const getSupersetCredentials = async () => {
    const accessToken = window.localStorage.getItem('accessToken');
    const data = await axios.get(`${process.env.REACT_APP_API_URL}/reporting_dashboard/dashboard/get_superset_cred`, {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        const payload = res?.data;
        const result = payload && typeof payload === 'object' ? (payload.data || payload) : {};
        const { username, password } = result || {};
        if (!username || !password) {
          throw new Error('Superset credentials missing in API response');
        }
        return { username, password };
      })
      .catch((error) => {
        console.error('getSupersetCredentials error', error);
        throw error;
      });

    return data;
  }

  // Get country name
  // const getSupersetCredentials = async () => {
  //   const accessToken = window.localStorage.getItem('accessToken');

  //   const data = await axios.get(`${process.env.REACT_APP_API_URL}/reporting_dashboard/dashboard/get_superset_cred`, {
  //     headers: {
  //       'Authorization': `Token ${accessToken}`,
  //       'Content-Type': 'application/json'
  //     }
  //   })
  //     .then((res) => {
  //       const results = humps.camelizeKeys(res?.data?.data);
  //       return results;
  //     })
  //     .catch((error) => {
  //       console.error(error)
  //     })

  //   return data;
  // }

  // Get country name
  const getCountryName = async (locationName) => {
    const accessToken = window.localStorage.getItem('accessToken');

    const data = await axios.get(`${process.env.REACT_APP_API_URL}/users/list_country?country=${locationName}`, {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        const results = humps.camelizeKeys(res?.data?.data);
        return results;
      })
      .catch((error) => {
        console.error(error)
      })

    return data;
  }

  // Get city name
  const getCityName = async (countryName, cityName) => {
    const accessToken = window.localStorage.getItem('accessToken');

    const data = await axios.get(`${process.env.REACT_APP_API_URL}/users/list_city?country=${countryName}&city=${cityName}`, {
      headers: {
        'Authorization': `Token ${accessToken}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        const results = humps.camelizeKeys(res?.data?.data);
        return results;
      })
      .catch((error) => {
        console.error(error)
      })

    return data;
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        cityDetails: state.cityDetails,
        method: 'jwt',
        login,
        logout,
        changePassword,
        changeUserPassword,
        forgotPassword,
        userslocalisation,
        updateProfilePicture,
        getProfilePicture,
        updateSideBar,
        getSideBar,
        deleteProfilePicture,
        setupMfa,
        verifyMfa,
        getMfaStatus,
        getCompanySettings,
        updateCompanySettings,
        updateLogo,
        deleteHeaderLogo,
        headerLogo,
        setHeaderLogo,
        favIconLogo,
        setFavIconLogo,
        updateFavIcoLogo,
        deleteFavIcoLogo,
        getLoginLogo,
        loginLogo,
        setLoginLogo,
        getCountryName,
        getCityName,
        profilePicture,
        setProfilePicture,
        mfaEnabled,
        setMfaEnabled,
        twoStepResendOtp,
        getSupersetCredentials,
        // verifyOtp,
        enableTwoStep, setEnableTwoStep, isExtId,
        verifyMfaOtp,
        verifyMfaBackupCode,
        mfaRequired, setMfaRequired
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
